import { render, staticRenderFns } from "./FamilyDraftTab.vue?vue&type=template&id=3535ef62&scoped=true"
import script from "./FamilyDraftTab.vue?vue&type=script&lang=js"
export * from "./FamilyDraftTab.vue?vue&type=script&lang=js"
import style0 from "./FamilyDraftTab.vue?vue&type=style&index=0&id=3535ef62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3535ef62",
  null
  
)

export default component.exports